export const IMPORT_SALARY_START = 'IMPORT_SALARY_START'
export const IMPORT_SALARY_PROGRESS = 'IMPORT_SALARY_PROGRESS'
export const IMPORT_SALARY_SUCCESS = 'IMPORT_SALARY_SUCCESS'
export const IMPORT_SALARY_FAILED = 'IMPORT_SALARY_FAILED'

export const EXPORT_SALARY_START = 'EXPORT_SALARY_START'
export const EXPORT_SALARY_SUCCESS = 'EXPORT_SALARY_SUCCESS'
export const EXPORT_SALARY_FAILED = 'EXPORT_SALARY_FAILED'
